module.exports = __webpack_public_path__ + "images/mapa_2_mobile.96945325.png";